import React, { useState } from "react";
import { Button, Input, Select } from "antd"
import FormItem from "antd/lib/form/FormItem";
import TextArea from "antd/lib/input/TextArea"
import Modal from "antd/lib/modal/Modal"
import { Formik } from "formik"
import { useContext, useEffect } from "react";
import * as Yup from 'yup';
import { Logger } from "../../utilites/loglySetup";
import { CompanyUserProfile } from "../../models/company-user-profile-interface"
import { AuthContext } from "../../utilites/auth";
import { CustomerServiceQueries } from "../../queries/customer-service-queries";
import { CompanySupportTier } from "../../models/company-support-tier-interface";

const { Option } = Select;

type Props = {
  isModalVisible: boolean,
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>,
  currentTierId: number,
  companyId: number,
}

const SupportTierChangeModal: React.FC<Props> = ({ 
    isModalVisible,
    setIsModalVisible,
    currentTierId,
    companyId
 }) => {
    const [supportId, setSupportId] = useState<number>(currentTierId);
    const getSupportTiersQuery = CustomerServiceQueries.useSupportTiers();
    const supportTierMutator = CustomerServiceQueries.useUpdateCompanySupportTier(companyId);

    useEffect(() => {
      if(supportId === 0 && !!getSupportTiersQuery.data) {
        setSupportId(getSupportTiersQuery.data.find(x => x.defaultTier)?.id ?? 0);
      }
    }, [supportId, getSupportTiersQuery.data])

    return (
        <Modal
            visible={isModalVisible}
            destroyOnClose
            centered
            onCancel={() => {
              setIsModalVisible(false);
            }}
            footer={[
                <Button id="CancelEmailButton" type="text" key="cancel" onClick={() => setIsModalVisible(false)}>
                  Cancel
                </Button>,
                <Button type="primary" key="submit"
                  className="email-submit-btn"
                  loading={getSupportTiersQuery.isLoading || supportTierMutator.isLoading}
                  onClick={() => {
                    const data: CompanySupportTier = {
                      companyId: companyId,
                      supportTierId: supportId
                    };
                    supportTierMutator.mutateAsync(data).then(() => setIsModalVisible(false));
                  }}
                  disabled={currentTierId === supportId}
                >
                  Save
                </Button>
            ]}
            title={"Change Support Tier"}
            getContainer={false}
        >
            <Select
              value={supportId}
              onChange={(val) => setSupportId(val)}
              className="full-width"
            >
              {getSupportTiersQuery.data?.map(tier => {
                return (
                  <Option key={tier.id} value={tier.id}>
                    {tier.name}
                  </Option>
                )
              })}
            </Select>
        </Modal>
    )
}

export default SupportTierChangeModal;